import React from 'react';
import './privacypolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className='container'>
        <h1>Nool Privacy Policy</h1>
        <p>Thank you for trusting Nool with your information. We’re committed to protecting your privacy and ensuring transparency. This Privacy Policy explains what data we collect, how we use it, and how we protect it. If you have any questions, please reach out at info@nool.com.</p>
        
        <h2>Who Are We?</h2>
        <p>We’re Nool, your neighborhood Community Book Cupid, dedicated to connecting you with textbooks in a safe, user-friendly way. Our registered office address is:</p>
        <p>10585 Akron St, Henderson, Colorado 80640</p>
        
        <h2>What Information Do We Collect?</h2>
        
        <h3>Information You Submit</h3>
        <ul>
          <li>Your name, ID, email, phone number, and a selfie.</li>
          <li>Payment Information: Bank account or credit card details.</li>
          <li>Address for verification and transaction purposes.</li>
          <li>Details about your interactions on the platform, including messages with other users.</li>
        </ul>
        
        <h3>Device and Usage Information</h3>
        <p>To enhance your experience, we may collect data like your mobile network, IP address, operating system, and phone settings. With your consent, we may also access your camera (for item photos) and geolocation (to show relevant listings nearby).</p>
        
        <h3>Social Media Information</h3>
        <p>If you connect your social media accounts, we may access basic information from those accounts.</p>
        
        <h3>Cookies</h3>
        <p>By using Nool, you agree to our use of cookies. Cookies help us track site usage to improve your experience. You can disable cookies in your browser settings.</p>
        
        <h2>How Do We Use Your Information?</h2>
        <ul>
          <li>To provide and improve our service, including communication and customer support.</li>
          <li>To ensure security, prevent fraud, and comply with legal obligations.</li>
          <li>To send relevant updates and marketing communications (you can opt out at any time).</li>
        </ul>
        
        <h2>Who Do We Share Your Data With?</h2>
        <p>We do not sell your data. However, we may share your information with:</p>
        <ul>
          <li>Employees and service providers who support our platform.</li>
          <li>Payment processors (e.g., Stripe) to facilitate transactions.</li>
          <li>Legal authorities when required by law.</li>
        </ul>
        
        <h2>Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access and update your information through your account.</li>
          <li>Request data deletion, subject to legal and security constraints.</li>
          <li>Opt out of marketing communications.</li>
        </ul>
        
        <h2>Data Security</h2>
        <p>We use SSL encryption and other safeguards to protect your data. Only authorized personnel can access sensitive information.</p>
        
        <h2>Contact Us</h2>
        <p>If you have any questions or concerns, please email us at info@nool.com.</p>
        
        <h2>Updates to This Policy</h2>
        <p>We may update this policy periodically. Please check this page for the latest information.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;